const updateVideoSize = require('./update-video-size');

module.exports = function () {
    var heroCarouselModuleClass = 'hero-carousel-module';
    var heroCarouselModuleSelector = '.' + heroCarouselModuleClass;

    if ($(heroCarouselModuleSelector).length === 0) {
        return;
    }

    var isIOS = function () {
        if (navigator != undefined) {
            if (navigator.platform != undefined) {
                if ([
                    'iPad Simulator',
                    'iPhone Simulator',
                    'iPod Simulator',
                    'iPad',
                    'iPhone',
                    'iPod'
                ].includes(navigator.platform)) {
                    return true;
                }
            }

            if (navigator.userAgent != undefined) {
                if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                    return true;
                }
            }
        }

        return false;
    }
   
    updateVideoSize();

    var carouselFunctionalityDisabledClass = 'hero-carousel-module--carousel-functionality-disabled';
    var carouselFunctionalityDisabledSelector = '.' + carouselFunctionalityDisabledClass;
    var autoplayActiveClass = 'hero-carousel-module--autoplay-active';
    var autoplayPausedClass = 'hero-carousel-module--autoplay-paused';

    var swiperClass = 'swiper';
    var swiperSelector = '.' + swiperClass;
    var swiperSlideClass = 'swiper-slide';
    var swiperSlideSelector = '.' + swiperSlideClass;
    var swiperSlideActiveClass = 'swiper-slide-active';
    var swiperSlideActiveSelector = '.' + swiperSlideActiveClass;
    var swiperPaginationClass = 'swiper-pagination';
    var swiperPaginationSelector = '.' + swiperPaginationClass;

    var wistiaPlayerSelector = 'wistia-player';
    var activeSlideWistiaPlayerSelector = swiperSlideActiveSelector + ' ' + wistiaPlayerSelector;

    var videoWrapperClass = 'hero-carousel-module__video-wrapper';
    var videoWrapperSelector = '.' + videoWrapperClass;
    var videoWrapperVideoVisibleClass = 'hero-carousel-module__video-wrapper--video-visible';
    var videoWrapperVideoVisibleSelector = '.' + videoWrapperVideoVisibleClass;

    var carouselNavigationItemClass = 'hero-carousel-module__navigation-item';
    var carouselNavigationItemSelector = '.' + carouselNavigationItemClass;
    var carouselNavigationItemActiveClass = 'hero-carousel-module__navigation-item--active'
    var carouselNavigationItemActiveSelector = '.' + carouselNavigationItemActiveClass;
    var carouselInnerProgressBarClass = 'hero-carousel-module__navigation-item-inner-progress-bar';
    var carouselInnerProgressBarSelector = '.' + carouselInnerProgressBarClass;
    var carouselOuterProgressBarClass = 'hero-carousel-module__navigation-item-outer-progress-bar';
    var carouselActiveInnerProgressBarSelector = carouselNavigationItemActiveSelector + ' ' + carouselInnerProgressBarSelector;
    var carouselProgressBarCssVariable = '--progress';

    var aosAnimateClass = 'aos-animate';
    var aosAnimateSelector = '.' + aosAnimateClass;

    var heroCarouselAosObserver = new MutationObserver(function (mutationList, observer) {
        for (var i = 0; i < mutationList.length; i++) {
            var mutation = mutationList[i];
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                var $aosElement = $(mutation.target);
                var $slide = $aosElement.closest(swiperSlideSelector);
                if ($aosElement.hasClass(aosAnimateClass) && !($slide.hasClass(swiperSlideActiveClass))) {
                    $aosElement.removeClass(aosAnimateClass);
                }
            }
        }
    });

    var heroCarouselSlideObserverConfig = { attributes: true, attributeFilter: ['class'] };
    $(heroCarouselModuleSelector).not(carouselFunctionalityDisabledSelector).find('[data-aos]').each(function () {
        heroCarouselAosObserver.observe(this, heroCarouselSlideObserverConfig);
    });

    $(videoWrapperSelector).each(function () {
        $videoWrapper = $(this);
        $videoPlayer = $videoWrapper.find(wistiaPlayerSelector);
        if ($videoPlayer.length) {
            if (isIOS()) {
                $videoPlayer[0].addEventListener('can-play-through', (event) => {
                    $(event.srcElement).closest(videoWrapperSelector).not(videoWrapperVideoVisibleSelector).addClass(videoWrapperVideoVisibleClass);
                });
            }
            else {
                $videoPlayer[0].addEventListener('can-play', (event) => {
                    $(event.srcElement).closest(videoWrapperSelector).not(videoWrapperVideoVisibleSelector).addClass(videoWrapperVideoVisibleClass);
                });
            }
        }
    });

    $(window).resize(function () {
        requestAnimationFrame(updateVideoSize);
    });

    if ($(heroCarouselModuleSelector).not(carouselFunctionalityDisabledSelector).length === 0) {
        return;
    }

    var canPlayAndPauseVideo = function () {
        return !isIOS();
    }

    var isAutoplayActive = function ($heroCarouselModule) {
        return $heroCarouselModule.hasClass(autoplayActiveClass);
    }

    var isAutoplayPaused = function ($heroCarouselModule)
    {
        return $heroCarouselModule.hasClass(autoplayPausedClass);
    }

    var startAutoplay = function ($heroCarouselModule) {
        var heroCarouselSwiper = $heroCarouselModule.find(swiperSelector)[0];
        if (heroCarouselSwiper != undefined && heroCarouselSwiper.swiper != undefined && heroCarouselSwiper.swiper.autoplay != undefined && heroCarouselSwiper.swiper.autoplay.start != undefined) {
            $heroCarouselModule.find(swiperSelector)[0].swiper.autoplay.start();
        }
    }

    var pauseAutoplay = function ($heroCarouselModule, shouldPauseSwiperAutoplay) {
        if (shouldPauseSwiperAutoplay) {
            var heroCarouselSwiper = $heroCarouselModule.find(swiperSelector)[0];
            if (heroCarouselSwiper != undefined && heroCarouselSwiper.swiper != undefined && heroCarouselSwiper.swiper.autoplay != undefined && heroCarouselSwiper.swiper.autoplay.pause != undefined) {
                heroCarouselSwiper.swiper.autoplay.pause();
            }
        }
        
        var $activeSlideVideo = $heroCarouselModule.find(activeSlideWistiaPlayerSelector);
        if (canPlayAndPauseVideo() && $activeSlideVideo.length && $activeSlideVideo[0].pause != undefined) {
            $activeSlideVideo[0].pause();
        }

        $heroCarouselModule.addClass(autoplayPausedClass);
    }

    var resumeAutoplay = function ($heroCarouselModule, shouldResumeSwiperAutoplay) {
        if (shouldResumeSwiperAutoplay) {
            var heroCarouselSwiper = $heroCarouselModule.find(swiperSelector)[0];
            if (heroCarouselSwiper != undefined && heroCarouselSwiper.swiper != undefined && heroCarouselSwiper.swiper.autoplay != undefined && heroCarouselSwiper.swiper.autoplay.resume != undefined) {
                heroCarouselSwiper.swiper.autoplay.resume();
            }
        }

        var $activeSlideVideo = $heroCarouselModule.find(activeSlideWistiaPlayerSelector);
        if (canPlayAndPauseVideo() && $activeSlideVideo.length && $activeSlideVideo[0].play != undefined) {
            $activeSlideVideo[0].play();
        }        

        $heroCarouselModule.removeClass(autoplayPausedClass);
    }

    var getSwiperHeroCarouselModule = function (swiper) {
        return $(swiper.wrapperEl).closest(heroCarouselModuleSelector);
    }

    var handleSwiperAutoplayPauseEvent = function (swiper) {
        var $heroCarouselModule = getSwiperHeroCarouselModule(swiper);
        pauseAutoplay($heroCarouselModule, false);
    }

    var handleSwiperAutoplayResumeEvent = function (swiper) {
        var $heroCarouselModule = getSwiperHeroCarouselModule(swiper);
        resumeAutoplay($heroCarouselModule, false);
    }

    var handleSwiperAutoplayStartEvent = function (swiper) {
        var $heroCarouselModule = getSwiperHeroCarouselModule(swiper);
        if (!($heroCarouselModule.hasClass(autoplayActiveClass))) {
            $heroCarouselModule.addClass(autoplayActiveClass);
        }
    }

    var handleSwiperAutoplayTimeLeftEvent = function (swiper, time, progress, $swiperPagination) {
        var activeProgressBar = $swiperPagination.find(carouselActiveInnerProgressBarSelector)[0]

        if (activeProgressBar != undefined && activeProgressBar.style != undefined) {
            if (progress < 0) {
                activeProgressBar.style.setProperty(carouselProgressBarCssVariable, 1);
            }
            else if (progress > 1) {
                activeProgressBar.style.setProperty(carouselProgressBarCssVariable, 0);
            }
            else {
                activeProgressBar.style.setProperty(carouselProgressBarCssVariable, 1 - progress);
            }
        }
    }

    var handleSwiperResizeEvent = function (swiper) {
        requestAnimationFrame(updateVideoSize);
    }

    var rewindPlayer = function (player){
        player.currentTime = 0;
    }

    var resetAosAnimations = function ($heroCarouselModule) {
        $heroCarouselModule.find(aosAnimateSelector).each(function () {
            $(this).removeClass(aosAnimateClass);
        });
    }

    var handleSwiperActiveIndexChangeEvent = function (swiper) {
        var $heroCarouselModule = getSwiperHeroCarouselModule(swiper);
        resetAosAnimations($heroCarouselModule);
    }

    var handleSwiperTransitionStartEvent = function (swiper) {
        var $heroCarouselModule = getSwiperHeroCarouselModule(swiper);

        $heroCarouselModule.find(carouselNavigationItemSelector).not(carouselNavigationItemActiveSelector).find(carouselInnerProgressBarSelector).each(function () {
            this.style.setProperty(carouselProgressBarCssVariable, 0);
        });

        $heroCarouselModule.find(swiperSlideSelector).not(swiperSlideActiveSelector).find(wistiaPlayerSelector).each(function () {
            if (canPlayAndPauseVideo() && this.state != undefined && this.state === 'playing' && this.pause != undefined) {
                this.pause();
            }
            if (this.currentTime != undefined && this.currentTime != 0) {
                setTimeout(rewindPlayer, 500, this);
            }
        });

        if (isAutoplayActive($heroCarouselModule) && isAutoplayPaused($heroCarouselModule)) {
            resumeAutoplay($heroCarouselModule);
        }

        var $activeSlide = $heroCarouselModule.find(swiperSlideActiveSelector);
        if ($activeSlide.length) {
            $activeSlide.find('.aos-init').addClass(aosAnimateClass);
        }
    }    

    $(heroCarouselModuleSelector).not(carouselFunctionalityDisabledSelector).each(function () {
        var $heroCarouselModule = $(this);
        var $swiperPagination = $heroCarouselModule.find(swiperPaginationSelector);

        var heroCarouselModuleSwiperSelector = '#' + $heroCarouselModule.attr('id') + ' ' + swiperSelector;
        var heroCarouselSwiper = new Swiper(heroCarouselModuleSwiperSelector, {
            a11y: true,
            autoplay: {
                delay: 8000
            },
            direction: 'horizontal',
            rewind: true,
            effect: 'fade',
            touchStartPreventDefault: false,
            fadeEffect: {
                crossFade: true
            },
            on: {
                activeIndexChange(swiper) {
                    handleSwiperActiveIndexChangeEvent(swiper);
                },
                autoplayStart(swiper) {
                    handleSwiperAutoplayStartEvent(swiper);
                },
                autoplayPause(swiper) {
                    handleSwiperAutoplayPauseEvent(swiper);
                },
                autoplayResume(swiper) {
                    handleSwiperAutoplayResumeEvent(swiper);
                },
                autoplayTimeLeft(s, time, progress) {
                    handleSwiperAutoplayTimeLeftEvent(s, time, progress, $swiperPagination);
                },
                resize(swiper) {
                    handleSwiperResizeEvent(swiper);
                },
                transitionStart(swiper) {
                    handleSwiperTransitionStartEvent(swiper);
                }
            },
            pagination: {
                el: swiperPaginationSelector,
                bulletClass: carouselNavigationItemClass,
                bulletActiveClass: carouselNavigationItemActiveClass,
                clickable: true,
                renderBullet: function (index, className) {
                    var $slide = $heroCarouselModule.find(swiperSlideSelector).eq(index);
                    var slideNavigationTitle = $slide.data('carouselNavigationTitle');
                    if (slideNavigationTitle == undefined) {
                        slideNavigationTitle = '';
                    }
                    var slideProgressBarColorClass = $slide.data('carouselNavigationProgressBarColorClass');
                    if (slideProgressBarColorClass == undefined) {
                        slideProgressBarColorClass = '';
                    }
                    return '<div class="' + className + '" tabindex role="button"><div class="hero-carousel-module__navigation-item-title">' + slideNavigationTitle + '</div><div class="' + carouselOuterProgressBarClass + '"><div class="' + carouselInnerProgressBarClass + ' ' + slideProgressBarColorClass + '"></div></div></div>'
                }
            },
        })
    });

    $('.hero-carousel-module__playback-pause-button').click(function () {
        var $heroCarouselModule = $(this).closest(heroCarouselModuleSelector);
        if (isAutoplayActive($heroCarouselModule) && !(isAutoplayPaused($heroCarouselModule))) {
            pauseAutoplay($heroCarouselModule, true);
        }
    });

    $('.hero-carousel-module__playback-play-button').click(function () {
        var $heroCarouselModule = $(this).closest(heroCarouselModuleSelector);
        if (isAutoplayActive($heroCarouselModule) && isAutoplayPaused($heroCarouselModule)) {
            resumeAutoplay($heroCarouselModule, true);
        }
        else {
            startAutoplay($heroCarouselModule);
        }
    });
};